// import React from "react";
// import PropTypes from "prop-types";
// import { Link } from "react-router-dom";
// import Table from "../components/common/table";
// import Level from "./Level";
// import Skills from "../ui/skills/index.js";
// import UserGroupName from "../components/common/UserGroupName";

// const UserTable = ({ users, onSort, selectedSort, ...rest }) => {
//   const columns = {
//     nickname: {
//       path: "nickname",
//       name: "nickname",
//       component: (user) => (
//         <div className="flex justify-center">
//           <Link
//             to={user._id}
//             state={{ user: user }}
//             className="hover:text-blue-400 font-bold"
//           >
//             {user.nickname}
//           </Link>
//         </div>
//       ),
//     },
//     skills: {
//       name: "skills",
//       component: (user) => <Skills skills={user.skill} />,
//     },
//     level: {
//       name: "уровень",
//       component: (user) => <Level id={user.level} />,
//     },
//     group: {
//       name: "group name",
//       component: (user) => <UserGroupName id={user.teamId} />,
//     },
//   };
//   return (
//     <Table
//       selectedSort={selectedSort}
//       onSort={onSort}
//       columns={columns}
//       data={users}
//     />
//   );
// };

// UserTable.propTypes = {
//   users: PropTypes.array.isRequired,
//   onSort: PropTypes.func.isRequired,
//   selectedSort: PropTypes.object.isRequired,
// };

// export default UserTable;
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Table from "../components/common/table";
import Level from "./Level";
import Skills from "../ui/skills/index.js";
import UserGroupName from "../components/common/UserGroupName";
import { useI18n } from "../i18n/LanguageContext";

const UserTable = ({ users, onSort, selectedSort, ...rest }) => {
  const { t } = useI18n();
  const columns = {
    nickname: {
      path: "nickname",
      name: t("user.name"),
      component: (user) => (
        <div className="flex justify-start">
          <Link
            to={user._id}
            state={{ user: user }}
            className="hover:text-blue-400 font-semibold text-base sm:text-lg transition-colors duration-200"
          >
            {user.nickname}
          </Link>
        </div>
      ),
    },
    skills: {
      name: t("user.skillsCol"),
      component: (user) => (
        <div className="py-1">
          <Skills skills={user.skill} />
        </div>
      ),
    },
    level: {
      name: t("user.levelCol"),
      component: (user) => (
        <div className="flex justify-center sm:justify-start">
          <Level id={user.level} />
        </div>
      ),
    },
    group: {
      name: t("user.teamCol"),
      component: (user) => (
        <div className="flex justify-center sm:justify-start">
          <UserGroupName id={user.teamId} />
        </div>
      ),
    },
  };

  // Мобильная карточка для каждого пользователя
  const MobileUserCard = ({ user }) => (
    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-4 mb-4 hover:shadow-lg transition-shadow duration-200">
      {/* Основная информация в строку */}
      <div className="flex items-center justify-between mb-3">
        <Link
          to={user._id}
          state={{ user: user }}
          className="hover:text-blue-400 font-semibold text-lg transition-colors duration-200"
        >
          {user.nickname}
        </Link>
        <Level id={user.level} />
      </div>

      {/* Навыки */}
      <div className="mb-3">
        <div className="text-sm text-gray-600 font-medium mb-2">{t("user.skills")}</div>
        <Skills skills={user.skill} />
      </div>

      {/* Команда */}
      <div className="flex items-center justify-between pt-3 border-t border-gray-100">
        <div className="text-sm text-gray-600 font-medium">{t("user.team")}</div>
        <UserGroupName id={user.teamId} />
      </div>
    </div>
  );

  return (
    <div>
      {/* Десктопная таблица (скрыта на мобильных) */}
      <div className="hidden md:block">
        <Table
          selectedSort={selectedSort}
          onSort={onSort}
          columns={columns}
          data={users}
        />
      </div>

      {/* Мобильные карточки (видны только на мобильных) */}
      <div className="md:hidden space-y-3">
        {users.map((user) => (
          <MobileUserCard key={user._id} user={user} />
        ))}
      </div>

      {/* Сообщение если нет пользователей */}
      {users.length === 0 && (
        <div className="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-300">
          <div className="text-6xl mb-4">👥</div>
          <h3 className="text-xl font-semibold text-gray-600 mb-2">
            {t("user.notFound")}
          </h3>
          <p className="text-gray-500">{t("user.search")}</p>
        </div>
      )}
    </div>
  );
};

UserTable.propTypes = {
  users: PropTypes.array.isRequired,
  onSort: PropTypes.func.isRequired,
  selectedSort: PropTypes.object.isRequired,
};

export default UserTable;
